import { render, staticRenderFns } from "./FrzChamberPrePackingRpt.vue?vue&type=template&id=72457da2"
import script from "./FrzChamberPrePackingRpt.vue?vue&type=script&lang=js"
export * from "./FrzChamberPrePackingRpt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports